import { useFormik } from 'formik';
import RootLayout from '../../layouts/RootLayout';
import FormInput from '../../../components/forms/FormInput';
import { Button } from '../../../components/buttons/Button';
import { useAuth } from '../../../lib/auth';
import { useState } from 'react';
import Alert from '../../../components/Alert.tsx';
import API from '../../../lib/api.ts';
import { transformLaravelToFormikErrors } from '../../../lib/helpers.ts';
import HeadLogo from '../../../components/logos/HeadLogo.tsx';

export default function ForgottenPasswordPage() {
    useAuth({
        middleware: 'guest',
        redirectTo: '/dashboard',
        tmp: 'ForgottenPasswordPage',
    });

    const [forgottenPasswordStatus, setForgottenPasswordStatus] = useState<
        string | undefined
    >(undefined);

    const {
        handleSubmit,
        handleChange,
        values,
        setSubmitting,
        isSubmitting,
        errors,
        touched,
        setErrors,
    } = useFormik({
        initialValues: { email: '' },
        onSubmit: (values) => {
            API.post('/forgot-password', values)
                .then((res) =>
                    setForgottenPasswordStatus(
                        res?.data?.status ??
                            'Žádost byla úspěšná, zkontrolujte svůj email'
                    )
                )
                .catch((err) => {
                    const errors = err?.response?.data?.errors;
                    if (errors)
                        setErrors(transformLaravelToFormikErrors(errors));
                })
                .finally(() => setSubmitting(false));
        },
    });

    return (
        <RootLayout>
            <main className="container mx-auto flex h-screen flex-col items-center justify-start  px-4 py-32">
                <HeadLogo />
                <h1>
                    {!forgottenPasswordStatus
                        ? 'Zapomenuté heslo'
                        : 'Zkontrolujte svůj e-mail'}
                </h1>
                <p className="mb-6 text-ink-800">
                    {!forgottenPasswordStatus
                        ? 'Zadejte svůj email a my vám zašleme odkaz pro obnovení hesla'
                        : 'Vaše žádost o obnovu hesla byla úspěšná. Zkontrolujte, prosím, svůj e-mail.'}
                </p>

                {forgottenPasswordStatus === undefined ? (
                    <div className="w-full max-w-[520px]">
                        <form
                            onSubmit={handleSubmit}
                            className="mx-auto flex w-full max-w-[400px] flex-col space-y-4"
                        >
                            <FormInput
                                name="email"
                                label="E-mail"
                                onChange={handleChange}
                                value={values.email}
                                type="email"
                                error={
                                    errors.email && touched.email
                                        ? errors.email
                                        : null
                                }
                                placeholder="Váš e-mail"
                            />

                            <Button
                                type="submit"
                                color="product"
                                isLoading={isSubmitting}
                                className="text-base"
                            >
                                Obnovit heslo
                            </Button>
                        </form>
                    </div>
                ) : (
                    <Alert type="success">{forgottenPasswordStatus}</Alert>
                )}
            </main>
        </RootLayout>
    );
}
